/* PETA COFFEE ROASTERS · comportamiento de las secciones (assets/peta.js) */
(function () {
  if (window.__peta) return; window.__peta = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Aviso flotante */
  var toastEl;
  function toast(html) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'peta peta-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = html; toastEl.classList.add('is-show');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-show'); }, 3200);
  }

  /* Chrome en escritorio: al elegir molienda o modalidad, Chrome intentaba "mostrar" el botón oculto
     y desplazaba la página entera (quedaba en blanco). Marcamos la opción nosotros, sin desplazar. */
  document.addEventListener('click', function (e) {
    var lab = e.target.closest('.peta-pills label, .peta-plan label');
    if (!lab) return;
    var inp = document.getElementById(lab.htmlFor);
    if (!inp || inp.disabled) return;
    e.preventDefault();
    if (!inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    try { inp.focus({ preventScroll: true }); } catch (_) {}
  });
  window.addEventListener('scroll', function () {
    var h = document.documentElement;
    if (h.scrollTop && getComputedStyle(h).overflowY === 'hidden') h.scrollTop = 0;
  }, { passive: true });

  /* Notas: abrir en una ventana sobre la página (el link sigue funcionando si se abre en otra pestaña) */
  var lastFocus;
  function closeModal(m) { m.hidden = true; document.documentElement.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-peta-article]');
    if (card && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      var tpl = document.getElementById(card.dataset.petaArticle);
      var m = document.querySelector('[data-peta-modal]');
      if (!tpl || !m) return;
      e.preventDefault();
      lastFocus = card;
      var box = m.querySelector('[data-peta-modal-content]');
      box.innerHTML = '';
      box.appendChild(tpl.content.cloneNode(true));
      var more = document.createElement('p');
      more.style.cssText = 'padding:0 clamp(22px,5vw,44px) clamp(22px,5vw,44px)';
      more.innerHTML = '<a class="peta-link" href="' + card.getAttribute('href') + '">Ver en su propia página →</a>';
      box.appendChild(more);
      m.hidden = false;
      m.querySelector('.peta-modal__dialog').scrollTop = 0;
      m.querySelector('[data-peta-modal-close]').focus({ preventScroll: true });
      return;
    }
    var m2 = e.target.closest('[data-peta-modal]');
    if (m2 && (e.target === m2 || e.target.closest('[data-peta-modal-close]'))) closeModal(m2);
  });
  document.addEventListener('keydown', function (e) {
    var m = document.querySelector('[data-peta-modal]:not([hidden])');
    if (m && e.key === 'Escape') closeModal(m);
  });

  /* Cantidad +/- y precio por variante */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-peta-q]');
    if (q) { var i = q.parentNode.querySelector('input'); i.value = Math.max(1, Math.min(20, (parseInt(i.value, 10) || 1) + Number(q.dataset.petaQ))); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('.peta-buyform input[name="id"]')) {
      var p = e.target.closest('form').querySelector('[data-peta-price]');
      if (p && e.target.dataset.price) p.textContent = e.target.dataset.price;
    }
  });

  /* Peta Club: elige la variante según modalidad + molienda */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-peta-options] input[name^="peta-opt-"]')) return;
    var f = e.target.closest('form'), data = f.querySelector('[data-peta-variants]');
    if (!data) return;
    var variants = JSON.parse(data.textContent), sel = [];
    for (var i = 1; i <= 3; i++) { var c = f.querySelector('input[name="peta-opt-' + i + '"]:checked'); if (c) sel.push(c.value); }
    var v = variants.filter(function (x) { return sel.every(function (s, k) { return x.options[k] === s; }); })[0];
    var btn = f.querySelector('[type=submit]');
    if (!v) { btn.disabled = true; return; }
    f.querySelector('input[name="id"]').value = v.id;
    btn.disabled = !v.available;
    var o1 = f.querySelector('input[name="peta-opt-1"]:checked');
    if (o1 && o1.dataset.plan) {
      var sp = f.querySelector('input[name="selling_plan"]');
      if (!sp) { sp = document.createElement('input'); sp.type = 'hidden'; sp.name = 'selling_plan'; f.appendChild(sp); }
      sp.value = o1.dataset.plan;
      var u = f.querySelector('[data-peta-unit]'); if (u && o1.dataset.unit) u.textContent = o1.dataset.unit;
      var n = f.querySelector('[data-peta-note]'); if (n && o1.dataset.note) n.textContent = o1.dataset.note;
    }
    var p = f.querySelector('[data-peta-price]');
    if (p) { var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CLP'; p.textContent = '$' + Math.round(v.price / 100).toLocaleString('es-CL'); }
  });

  /* Agregar al carrito sin salir de la página y actualizar el carrito del tema al instante */
  function refreshThemeCart(cart, root) {
    // 1) Aviso que entiende el tema Horizon (burbuja del carrito y cajón)
    try {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'peta', data: { itemCount: cart.item_count, source: 'product-form-component' } } }));
    } catch (_) {}
    // 2) Volver a pedir el encabezado y el cajón del carrito ya actualizados y reemplazarlos
    var els = $$('[id^="shopify-section-"]').filter(function (el) { return /header|cart/i.test(el.id); });
    if (!els.length) return;
    var ids = els.map(function (el) { return el.id.replace('shopify-section-', ''); });
    fetch(root + '?sections=' + encodeURIComponent(ids.join(',')), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sections) {
        if (!sections) return;
        els.forEach(function (el) {
          var html = sections[el.id.replace('shopify-section-', '')];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById(el.id);
          if (!fresh) return;
          // conserva el cajón cerrado/abierto tal como estaba; solo cambia el contenido
          el.innerHTML = fresh.innerHTML;
        });
      })
      .catch(function () {});
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches('[data-peta-buy]') || !window.fetch) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]');
    var label = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Agregando…';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) {
        btn.innerHTML = '✓ Agregado';
        toast('Agregado: ' + item.quantity + ' × ' + item.product_title + (item.variant_title ? ' · ' + item.variant_title : '') + ' <a href="' + root + 'cart">Ver carrito</a>');
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) { refreshThemeCart(cart, root); })
      .catch(function (err) { btn.innerHTML = label; toast((err && err.description) || 'No pudimos agregarlo. Intenta de nuevo.'); })
      .then(function () { setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1800); });
  });

  /* Copiar código de descuento */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-peta-copy]'); if (!b) return;
    var code = b.parentNode.querySelector('[data-peta-code]').textContent.trim();
    var done = function () { b.textContent = 'Copiado'; setTimeout(function () { b.textContent = 'Copiar'; }, 1800); };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, function () {}); else done();
  });

  /* Pestañas de preparación */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-peta-tabs] [role=tab]'); if (!t) return;
    var box = t.closest('[data-peta-tabs]');
    $$('[role=tab]', box).forEach(function (x) { x.setAttribute('aria-selected', x === t); });
    $$('[role=tabpanel]', box).forEach(function (p) { p.hidden = p.id !== t.getAttribute('aria-controls'); });
  });

  /* Temporizador (prensa francesa, etc.) */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-peta-timer-start]'), r = e.target.closest('[data-peta-timer-reset]');
    if (!s && !r) return;
    var panel = (s || r).closest('.peta-recipe'); var ring = $('[data-peta-timer]', panel); if (!ring) return;
    var total = Number(ring.dataset.petaTimer), C = 276.46, fg = $('.fg', ring), txt = $('[data-peta-timer-txt]', ring), lbl = $('[data-peta-timer-lbl]', ring), start = $('[data-peta-timer-start]', panel);
    ring._left = ring._left == null ? total : ring._left;
    var paint = function () { txt.textContent = Math.floor(ring._left / 60) + ':' + String(ring._left % 60).padStart(2, '0'); fg.setAttribute('stroke-dashoffset', (C * (1 - ring._left / total)).toFixed(2)); };
    if (r) { clearInterval(ring._run); ring._run = null; ring._left = total; paint(); lbl.textContent = 'Infusión'; start.textContent = 'Iniciar ' + total / 60 + ':00'; return; }
    if (ring._run) { clearInterval(ring._run); ring._run = null; start.textContent = 'Continuar'; return; }
    if (ring._left <= 0) ring._left = total;
    start.textContent = 'Pausar'; lbl.textContent = 'Infusionando';
    ring._run = setInterval(function () {
      ring._left--; paint();
      if (ring._left <= 0) { clearInterval(ring._run); ring._run = null; lbl.textContent = '¡A prensar!'; start.textContent = 'Otra vez'; toast('Listo: presiona el émbolo y sirve'); }
    }, 1000);
  });

  function onReady(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  onReady(function () {
    /* Mapa: dibuja la ruta al aparecer */
    if ('IntersectionObserver' in window) {
      var mo = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-go'); mo.unobserve(en.target); } }); }, { threshold: .3 });
      $$('[data-peta-map]').forEach(function (m) { mo.observe(m); });
      /* Barra de compra fija en móvil */
      var sticky = $('[data-peta-sticky]'), buy = $('#peta-buybox');
      if (sticky && buy) new IntersectionObserver(function (es) { sticky.classList.toggle('is-show', !es[0].isIntersecting); }).observe(buy);
    } else { $$('[data-peta-map]').forEach(function (m) { m.classList.add('is-go'); }); }

    /* Peta Club con Mercado Pago: tras enviar los datos, ir al pago */
    var mp = $('[data-peta-mp]');
    if (mp) {
      var box = document.getElementById('peta-club-pago');
      if (box) box.scrollIntoView({ block: 'center' });
      setTimeout(function () { location.href = mp.href; }, 2500);
    }

    /* Ventana 10% */
    var pop = $('[data-peta-pop]');
    if (pop) {
      var seen = false; try { seen = !!localStorage.getItem('peta_pop'); } catch (_) {}
      var open = function () { pop.hidden = false; var x = $('[data-peta-pop-close]', pop); x && x.focus(); try { localStorage.setItem('peta_pop', '1'); } catch (_) {} };
      var close = function () { pop.hidden = true; };
      pop.addEventListener('click', function (e) { if (e.target === pop || e.target.closest('[data-peta-pop-close]')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
      if (pop.hasAttribute('data-open-now') && /peta-pop/.test(location.hash)) open();
      else if (pop.hasAttribute('data-design')) { /* en el editor: se abre al seleccionar la sección */
        document.addEventListener('shopify:section:select', function (e) { if (pop.closest('.shopify-section') && e.target.contains(pop)) open(); });
        document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(pop)) close(); });
      }
      else if (!seen) setTimeout(open, (Number(pop.dataset.delay) || 9) * 1000);
    }
  });
  /* Próximo origen: muestra el "¡Listo!" solo si se envió este formulario (no el de Peta Friends) */
  document.addEventListener('submit', function (e) {
    if (e.target.matches('[data-peta-notify]')) { try { sessionStorage.setItem('peta-notify', '1'); } catch (_) {} }
  });
  onReady(function () {
    var ok = document.querySelector('[data-peta-notify-ok]');
    if (!ok) return;
    var mine = false; try { mine = sessionStorage.getItem('peta-notify') === '1'; sessionStorage.removeItem('peta-notify'); } catch (_) {}
    if (mine) {
      ok.hidden = false;
      var f = ok.parentNode.querySelector('[data-peta-notify-fields]'); if (f) f.hidden = true;
      var sec = document.getElementById('peta-proximo'); if (sec) sec.scrollIntoView({ block: 'center' });
    }
  });
})();
